import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ title, description, icon, path, color = 'primary' }) => {
  const navigate = useNavigate();

  const colorClasses = {
    primary: 'bg-primary/10 hover:bg-primary/20 text-primary',
    secondary: 'bg-secondary/10 hover:bg-secondary/20 text-secondary',
    accent: 'bg-accent/10 hover:bg-accent/20 text-accent',
    success: 'bg-success/10 hover:bg-success/20 text-success',
  };

  return (
    <button
      onClick={() => navigate(path)}
      className={`${colorClasses?.[color]} rounded-lg p-4 md:p-6 transition-smooth text-left w-full border border-transparent hover:border-${color}/20 hover:shadow-warm`}
    >
      <div className="flex items-start gap-3 md:gap-4">
        <div className="flex-shrink-0">
          <Icon name={icon} size={24} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-heading font-semibold mb-1 md:mb-2">
            {title}
          </h3>
          <p className="text-xs md:text-sm opacity-80 font-caption">
            {description}
          </p>
        </div>
        <Icon name="ArrowRight" size={20} className="flex-shrink-0 mt-1" />
      </div>
    </button>
  );
};

export default QuickActionCard;